type CancelToken = {
  token: any;
  cancel(): void;
};
export type Request = {
  key: string;
  url: string;
  cancelToken: CancelToken;
};

export class RequestQueue {
  private collections: Request[] = [];

  enqueue(element: Request) {
    // if (this.isEmpty()) {
    //   this.collections.push(element);
    // } else {
    //   const existed = this.collections.find((n) => n.url === element.url);
    //   let added = false;
    //   if (!added && !existed) {
    //     this.collections.push(element);
    //   }
    // }
    this.collections.push(element);
  }

  dequeue() {
    return this.collections.shift();
  }

  remove(key: string) {
    this.collections.splice(
      this.collections.findIndex((r) => r.key === key),
      1
    );
  }

  empty() {
    this.collections = [];
  }

  isEmpty() {
    return this.collections.length === 0;
  }

  length() {
    return this.collections.length;
  }
}
